module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-icon",
    class: {
      'back': _vm.back
    },
    attrs: {
      "id": "hamberger-menu"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-icon-bars"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-409a196a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HamburgerIcon.vue
// module id = 457
// module chunks = 2